import {
  ActionIcon as MantineActionIcon,
  ActionIconProps as MantineActionIconProps,
  Tooltip,
} from "@mantine/core"
import {
  IconCopy,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconRefresh,
  IconTrash,
  IconX,
} from "@tabler/icons-react"

import { ButtonVariants } from "../../atoms/Button/Button"

export const ActionTypes = [
  "copy",
  "download",
  "edit",
  "delete",
  "external-link",
  "refresh",
  "cancel",
] as const
export type ActionTypes = (typeof ActionTypes)[number]

type ActionIconProps = {
  type: ActionTypes
  variant?: ButtonVariants
  toolTip?: string
  size?: number
  loading?: boolean
} & React.DOMAttributes<HTMLButtonElement> &
  MantineActionIconProps

const renderIcon = (type: ActionIconProps["type"], size: number) => {
  switch (type) {
    case "download":
      return <IconDownload size={size} />
    case "copy":
      return <IconCopy size={size} />
    case "edit":
      return <IconEdit size={size} />
    case "delete":
      return <IconTrash size={size} />
    case "external-link":
      return <IconExternalLink size={size} />
    case "refresh":
      return <IconRefresh size={size} />
    case "cancel":
      return <IconX size={size} />
    default:
      return null
  }
}

export const ActionIcon = ({
  type,
  variant = type === "delete" ? "tertiary-critical" : "tertiary",
  toolTip,
  size = 24,
  ...props
}: ActionIconProps) => {
  const icon = renderIcon(type, size)
  if (!icon) return null

  const iconElement = (
    <MantineActionIcon
      h={size * 1.5}
      w={size * 1.5}
      loaderProps={{
        size,
        type: "oval",
      }}
      variant={variant}
      title={toolTip}
      {...props}
    >
      {icon}
    </MantineActionIcon>
  )
  return toolTip ? (
    <Tooltip label={toolTip}>{iconElement}</Tooltip>
  ) : (
    iconElement
  )
}
